import IconWithText from './IconWithText';

export default IconWithText;